export default __webpack_public_path__ + "static/media/dtmf-8.dadcf8c4.mp3";